const UserFeatures = ({
  canAccessAnalytics = false,
  canAccessBilling = false,
  canAccessBusinessVerificationLite = false,
  canAccessConnectedExperience = false,
  canAccessContacts = false,
  canAccessDeactivationWorkflow = false,
  canAccessFeatureLaunchNotifications = false,
  canAccessFeedClaimAndConvert = false,
  canAccessInvoicePayments = false,
  canAccessListingCriteria = false,
  canAccessMainAccountSettings = false,
  canAccessMainAnalytics = false,
  canAccessMainBilling = false,
  canAccessMainContactSupport = false,
  canAccessMainContacts = false,
  canAccessMainHelp = false,
  canAccessMainMaintenanceTracker = false,
  canAccessMainMessages = false,
  canAccessMainMyProperties = false,
  canAccessMainNotificationCenter = false,
  canAccessMainPayments = false,
  canAccessMainResources = false,
  canAccessMainSecuritySettings = false,
  canAccessMessages = false,
  canAccessModularListing = false,
  canAccessMultiFamilyResources = false,
  canAccessNewPhotoUpload = false,
  canAccessPostActivationFeedListingEdits = false,
  canAccessPostActivationListingEdits = false,
  canAccessUserManagement = false,
  canAccessUserManagementApplicationPermission = false,
  canAddListing = false,
  canEditMultifamilyFeedListingContactInformation = false,
  canRespondToReview = false,
  canSwitchListingSource = false,
  canUpdateListing = false,
  canViewClaimFeedListing = false,
  canViewContactEmailDeliverability = false,
  canViewFeedListingDetails = false,
  canViewOnboardingFlow = false,
  canViewSingleFamilyFeedListingDetails = false,
} = {}) => ({
  canAccessAnalytics: Boolean(canAccessAnalytics),
  canAccessBilling: Boolean(canAccessBilling),
  canAccessBusinessVerificationLite: Boolean(canAccessBusinessVerificationLite),
  canAccessConnectedExperience: Boolean(canAccessConnectedExperience),
  canAccessContacts: Boolean(canAccessContacts),
  canAccessDeactivationWorkflow: Boolean(canAccessDeactivationWorkflow),
  canAccessFeatureLaunchNotifications: Boolean(canAccessFeatureLaunchNotifications),
  canAccessFeedClaimAndConvert: Boolean(canAccessFeedClaimAndConvert),
  canAccessInvoicePayments: Boolean(canAccessInvoicePayments),
  canAccessListingCriteria: Boolean(canAccessListingCriteria),
  canAccessMainAccountSettings: Boolean(canAccessMainAccountSettings),
  canAccessMainAnalytics: Boolean(canAccessMainAnalytics),
  canAccessMainBilling: Boolean(canAccessMainBilling),
  canAccessMainContactSupport: Boolean(canAccessMainContactSupport),
  canAccessMainContacts: Boolean(canAccessMainContacts),
  canAccessMainHelp: Boolean(canAccessMainHelp),
  canAccessMainMaintenanceTracker: Boolean(canAccessMainMaintenanceTracker),
  canAccessMainMessages: Boolean(canAccessMainMessages),
  canAccessMainMyProperties: Boolean(canAccessMainMyProperties),
  canAccessMainNotificationCenter: Boolean(canAccessMainNotificationCenter),
  canAccessMainPayments: Boolean(canAccessMainPayments),
  canAccessMainResources: Boolean(canAccessMainResources),
  canAccessMainSecuritySettings: Boolean(canAccessMainSecuritySettings),
  canAccessMessages: Boolean(canAccessMessages),
  canAccessModularListing: Boolean(canAccessModularListing),
  canAccessMultiFamilyResources: Boolean(canAccessMultiFamilyResources),
  canAccessNewPhotoUpload: Boolean(canAccessNewPhotoUpload),
  canAccessPostActivationFeedListingEdits: Boolean(canAccessPostActivationFeedListingEdits),
  canAccessPostActivationListingEdits: Boolean(canAccessPostActivationListingEdits),
  canAccessUserManagement: Boolean(canAccessUserManagement),
  canAccessUserManagementApplicationPermission: Boolean(canAccessUserManagementApplicationPermission),
  canAddListing: Boolean(canAddListing),
  canEditMultifamilyFeedListingContactInformation: Boolean(canEditMultifamilyFeedListingContactInformation),
  canRespondToReview: Boolean(canRespondToReview),
  canSwitchListingSource: Boolean(canSwitchListingSource),
  canUpdateListing: Boolean(canUpdateListing),
  canViewClaimFeedListing: Boolean(canViewClaimFeedListing),
  canViewContactEmailDeliverability: Boolean(canViewContactEmailDeliverability),
  canViewFeedListingDetails: Boolean(canViewFeedListingDetails),
  canViewOnboardingFlow: Boolean(canViewOnboardingFlow),
  canViewSingleFamilyFeedListingDetails: Boolean(canViewSingleFamilyFeedListingDetails),
});

const UserSummary = ({ totalListingCount = 0, activeListingCount = 0, isPartialResponse = false } = {}) => ({
  totalListingCount: Number(totalListingCount),
  activeListingCount: Number(activeListingCount),
  isPartialResponse: Boolean(isPartialResponse),
});

const User = ({
  loggedIn = false,
  userToken = '',
  email = '',
  encodedZuid = '',
  hasSeenNewPaymentsPage = false,
  hasStrongAuthentication = false,
  isInitialMultiFactorAuthenticationRequired = false,
  roles = [],
  features = {},
  isMultifamilyCustomer = false,
  isPostingPathAdmin = false,
  isSingleFamilyEnterpriseCustomer = false,
  paymentsAcceptedCount = 0,
  summary = {
    totalListingCount: 0,
    activeListingCount: 0,
    isPartialResponse: false,
  },
} = {}) => {
  const userModel = {
    loggedIn: Boolean(loggedIn),
    userToken: String(userToken),
    email: String(email),
    encodedZuid: String(encodedZuid),
    hasSeenNewPaymentsPage: Boolean(hasSeenNewPaymentsPage),
    hasStrongAuthentication: Boolean(hasStrongAuthentication),
    isInitialMultiFactorAuthenticationRequired: Boolean(isInitialMultiFactorAuthenticationRequired),
    roles: [].concat(roles),
    features: UserFeatures(features),
    isMultifamilyCustomer: Boolean(isMultifamilyCustomer),
    isPostingPathAdmin: Boolean(isPostingPathAdmin),
    isSingleFamilyEnterpriseCustomer: Boolean(isSingleFamilyEnterpriseCustomer),
    paymentsAcceptedCount: Number(paymentsAcceptedCount),
    summary: UserSummary(summary),
  };

  return userModel;
};

export default User;

export type UserProps = ReturnType<typeof User>;
